import React, { memo } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectLoading } from '../../selectors/clients';

function Loading({ loading }) {
  let view = <></>;

  if (loading && loading.length > 0) {
    view = (
      <div
        style={{
          position: 'absolute',
          width: '100%',
          height: '100vh',
          zIndex: '1',
          background: 'rgba(1,1,1,.35)',
        }}
      >
        <div
          style={{
            margin: '40vh auto 0 auto',
            position: 'relative',
            textAlign: 'center',
            color: 'white',
          }}
        >
          <h1>{loading.join(' | ')}</h1>
        </div>
      </div>
    );
  }

  return <>{view}</>;
}

Loading.propTypes = {
  loading: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])).isRequired,
};

const mapStateToProps = createStructuredSelector({
  loading: makeSelectLoading(),
});

export function mapDispatchToProps() {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(Loading);
